<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title>
        <v-toolbar-title>GL Post Account</v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6 v-if="!newGLPostAcct">
              <v-autocomplete
                :label="labels.acctYr"
                :items="acctYrList"
                v-model="glPostAcctForm.acctYr"
                item-text="label"
                item-value="value"
                @change="fetchGLPostAcct"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.acctYr }}</v-subheader>
              <div class="title">{{ glPostAcctForm.acctYr }}</div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <template v-if="showDet">
            <v-data-table :headers="headers" :items="items" :loading="loading" hide-default-footer>
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-center">{{ row.item.mth }}</td>
                  <td class="text-right">{{ row.item.origBal }}</td>
                  <td class="text-right">{{ row.item.localBal }}</td>
                  <td><!-- Blank cell --></td>
                  <td><!-- Blank cell --></td>
                </tr></template
              >
            </v-data-table>
            <!-- <v-layout wrap>
              <v-flex xs6>
                <div class="body-2">Original Balance</div>
              </v-flex>
              <v-flex xs6>
                <div class="body-2">Local Balance</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-for="item in acctMth" :key="item.value">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{item.label}}</v-subheader>
                <div class="title">{{glPostAcctForm['origBal' + item.value]}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{item.label}}</v-subheader>
                <div class="title">{{glPostAcctForm['localBal' + item.value]}}</div>
              </v-flex>
            </v-layout> -->
            <v-divider></v-divider>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ glPostAcctForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ glPostAcctForm.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ glPostAcctForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ glPostAcctForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-btn class="mr-2" color="error" @click="doCancel">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number.js'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      acctYrList: [],
      labels: {
        glacctNo: 'GL Account No.',
        branch: 'Branch',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        description: 'Description',
        curr: 'Curency',
        parentAcctNo: 'Parent Account No.',
        acctYr: 'Accounting Year',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        modifiedProgId: 'Modified Program'
      },
      glPostAcctForm: {
        branch: null,
        brnDesc: null,
        glacctNo: null,
        fund: null,
        fundDesc: null,
        acctNoSfx: null,
        acctNoSfxDesc: null,
        acctYr: null,
        description: null,
        curr: null,
        currDesc: null,
        parentAcctNo: null,
        parentFund: null,
        parentAcctNoSfx: null,
        origBalBf: parseFloat(0).toFixed(2),
        origBal01: parseFloat(0).toFixed(2),
        origBal02: parseFloat(0).toFixed(2),
        origBal03: parseFloat(0).toFixed(2),
        origBal04: parseFloat(0).toFixed(2),
        origBal05: parseFloat(0).toFixed(2),
        origBal06: parseFloat(0).toFixed(2),
        origBal07: parseFloat(0).toFixed(2),
        origBal08: parseFloat(0).toFixed(2),
        origBal09: parseFloat(0).toFixed(2),
        origBal10: parseFloat(0).toFixed(2),
        origBal11: parseFloat(0).toFixed(2),
        origBal12: parseFloat(0).toFixed(2),
        origBal13: parseFloat(0).toFixed(2),
        localBalBf: parseFloat(0).toFixed(2),
        localBal01: parseFloat(0).toFixed(2),
        localBal02: parseFloat(0).toFixed(2),
        localBal03: parseFloat(0).toFixed(2),
        localBal04: parseFloat(0).toFixed(2),
        localBal05: parseFloat(0).toFixed(2),
        localBal06: parseFloat(0).toFixed(2),
        localBal07: parseFloat(0).toFixed(2),
        localBal08: parseFloat(0).toFixed(2),
        localBal09: parseFloat(0).toFixed(2),
        localBal10: parseFloat(0).toFixed(2),
        localBal11: parseFloat(0).toFixed(2),
        localBal12: parseFloat(0).toFixed(2),
        localBal13: parseFloat(0).toFixed(2),
        createdProgId: null,
        modifiedProgId: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      acctMth: [
        { label: 'B/F', value: 'Bf' },
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' }
      ],
      newGLPostAcct: false,
      showDet: false,
      currYrExist: false,
      headers: [
        { text: 'Month', value: 'mth', sortable: false, align: 'center' },
        { text: 'Original Balance', value: 'origBal', sortable: false, align: 'right' },
        { text: 'Local Balance', value: 'localBal', sortable: false, align: 'right' },
        { text: '', value: '', sortable: false, align: 'right' },
        { text: '', value: '', sortable: false, align: 'right' }
      ],
      items: [],
      loading: false
    }
  },
  created() {
    if (!this.glacctNoId.branch && !this.glacctNoId.glacctNo) {
      const jsonData = JSON.parse(sessionStorage.getItem('glacctNo'))
      if (jsonData && jsonData.branch && jsonData.glacctNo) {
        this.$store.commit('GLACCTNO_COMMIT_KEY', jsonData)
      } else {
        this.$router.push({ name: 'glAcctNoList' })
      }
    }
  },
  methods: {
    async fetchGLAcctNo() {
      const apiURI = this.menu.glacctNo
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glPostAcctForm.branch = data.glacctNo.branch
            if (data.branch) {
              this.glPostAcctForm.brnDesc = data.branch.brnDesc
            }
            this.glPostAcctForm.glacctNo = data.glacctNo.glacctNo
            this.glPostAcctForm.fund = data.glacctNo.fund
            if (data.fund) {
              this.glPostAcctForm.fundDesc = data.fund.fundDesc
            }
            this.glPostAcctForm.acctNoSfx = data.glacctNo.acctNoSfx
            if (data.acctNoSfx) {
              this.glPostAcctForm.acctNoSfxDesc = data.acctNoSfx.description
            }
            this.glPostAcctForm.description = data.glacctNo.description
            this.glPostAcctForm.curr = data.glacctNo.curr
            if (data.curr) {
              this.glPostAcctForm.currDesc = data.curr.currDesc
            }
            this.glPostAcctForm.parentAcctNo = data.glacctNo.parentAcctNo
            this.glPostAcctForm.parentFund = data.glacctNo.parentFund
            this.glPostAcctForm.parentAcctNoSfx = data.glacctNo.parentAcctNoSfx
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doInit() {
      await this.fetchGLAcctNo()
      const apiURI = this.menu.glPostAcctYrList
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data.hasContent) {
            const { data } = result.data
            if (data) {
              this.acctYrList = []
              data.map((result) => {
                this.acctYrList.push(result)
              })
              this.glPostAcctForm.acctYr = this.acctYrList[this.acctYrList.length - 1].value
              this.fetchGLPostAcct()
            }
            await this.checkCurrYr()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async fetchGLPostAcct() {
      const apiURI = this.menu.glPostAcct
      if (apiURI) {
        try {
          this.loading = true
          const expand = this.glacctNoId
          expand.acctYr = this.glPostAcctForm.acctYr
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            this.acctMth.map((mth) => {
              const convertList = {
                mth: mth.label,
                origBal: formatDisplayNumber(data.glPostAcct['origBal' + mth.value]),
                localBal: formatDisplayNumber(data.glPostAcct['localBal' + mth.value])
              }
              this.items.push(convertList)
            })
            // this.glPostAcctForm.origBalBf = formatDisplayNumber(data.glPostAcct.origBalBf)
            // this.glPostAcctForm.origBal01 = formatDisplayNumber(data.glPostAcct.origBal01)
            // this.glPostAcctForm.origBal02 = formatDisplayNumber(data.glPostAcct.origBal02)
            // this.glPostAcctForm.origBal03 = formatDisplayNumber(data.glPostAcct.origBal03)
            // this.glPostAcctForm.origBal04 = formatDisplayNumber(data.glPostAcct.origBal04)
            // this.glPostAcctForm.origBal05 = formatDisplayNumber(data.glPostAcct.origBal05)
            // this.glPostAcctForm.origBal06 = formatDisplayNumber(data.glPostAcct.origBal06)
            // this.glPostAcctForm.origBal07 = formatDisplayNumber(data.glPostAcct.origBal07)
            // this.glPostAcctForm.origBal08 = formatDisplayNumber(data.glPostAcct.origBal08)
            // this.glPostAcctForm.origBal09 = formatDisplayNumber(data.glPostAcct.origBal09)
            // this.glPostAcctForm.origBal10 = formatDisplayNumber(data.glPostAcct.origBal10)
            // this.glPostAcctForm.origBal11 = formatDisplayNumber(data.glPostAcct.origBal11)
            // this.glPostAcctForm.origBal12 = formatDisplayNumber(data.glPostAcct.origBal12)
            // this.glPostAcctForm.origBal13 = formatDisplayNumber(data.glPostAcct.origBal13)
            // this.glPostAcctForm.localBalBf = formatDisplayNumber(data.glPostAcct.localBalBf)
            // this.glPostAcctForm.localBal01 = formatDisplayNumber(data.glPostAcct.localBal01)
            // this.glPostAcctForm.localBal02 = formatDisplayNumber(data.glPostAcct.localBal02)
            // this.glPostAcctForm.localBal03 = formatDisplayNumber(data.glPostAcct.localBal03)
            // this.glPostAcctForm.localBal04 = formatDisplayNumber(data.glPostAcct.localBal04)
            // this.glPostAcctForm.localBal05 = formatDisplayNumber(data.glPostAcct.localBal05)
            // this.glPostAcctForm.localBal06 = formatDisplayNumber(data.glPostAcct.localBal06)
            // this.glPostAcctForm.localBal07 = formatDisplayNumber(data.glPostAcct.localBal07)
            // this.glPostAcctForm.localBal08 = formatDisplayNumber(data.glPostAcct.localBal08)
            // this.glPostAcctForm.localBal09 = formatDisplayNumber(data.glPostAcct.localBal09)
            // this.glPostAcctForm.localBal10 = formatDisplayNumber(data.glPostAcct.localBal10)
            // this.glPostAcctForm.localBal11 = formatDisplayNumber(data.glPostAcct.localBal11)
            // this.glPostAcctForm.localBal12 = formatDisplayNumber(data.glPostAcct.localBal12)
            // this.glPostAcctForm.localBal13 = formatDisplayNumber(data.glPostAcct.localBal13)
            this.glPostAcctForm.createdProgId = data.glPostAcct.createdProgId
            this.glPostAcctForm.modifiedProgId = data.glPostAcct.modifiedProgId
            this.glPostAcctForm.createdBy = data.createdBy
            this.glPostAcctForm.createdDate = data.createdDate
            this.glPostAcctForm.modifiedBy = data.modifiedBy
            this.glPostAcctForm.modifiedDate = data.modifiedDate
            this.showDet = true
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async checkCurrYr() {
      if (this.acctYrList.length === 0) {
        this.currYrExist = false
        return
      }
      const currYr = new Date().getFullYear()
      const apiURI = this.menu.glPostAcct
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          expand.acctYr = currYr
          await this.$http.get(expandURI(apiURI, expand))
          this.currYrExist = true
        } catch (err) {
          this.currYrExist = false
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'glAcctNoList' })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'glAcctNoDet' && to.name !== 'glBudget') {
      sessionStorage.removeItem('glacctNo')
    }
    next()
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
